import { EntityProp, EntityPropList, ePropType } from '@abp/ng.components/extensible';
import { eIdentityComponents, IdentityEntityPropContributors } from '@volo/abp.ng.identity';
import { IdentityUserDto } from '@volo/abp.ng.identity/proxy';
import { of } from 'rxjs';

/**
 * Creates the PaypalPayerId column prop for the Identity Users grid.
 */
const paypalPayerIdProp = new EntityProp<IdentityUserDto>({
  type: ePropType.String,
  name: 'paypalPayerId',
  displayName: 'PayPal Payer ID',
  sortable: false,
  columnWidth: 180,
  valueResolver: (data) => {
    const paypalPayerId = (data.record as any)?.paypalPayerId;
    return of(paypalPayerId || 'null');
  },
});

/**
 * Creates the PaypalEmailAddress column prop for the Identity Users grid.
 */
const paypalEmailAddressProp = new EntityProp<IdentityUserDto>({
  type: ePropType.String,
  name: 'paypalEmailAddress',
  displayName: 'PayPal Email',
  sortable: false,
  columnWidth: 220,
  valueResolver: (data) => {
    const paypalEmailAddress = (data.record as any)?.paypalEmailAddress;
    return of(paypalEmailAddress || 'null');
  },
});

/**
 * Creates the KlaviyoProfileId column prop for the Identity Users grid.
 */
const klaviyoProfileIdProp = new EntityProp<IdentityUserDto>({
  type: ePropType.String,
  name: 'klaviyoProfileId',
  displayName: 'Klaviyo Profile ID',
  sortable: false,
  columnWidth: 180,
  valueResolver: (data) => {
    const klaviyoProfileId = (data.record as any)?.klaviyoProfileId;
    return of(klaviyoProfileId || 'null');
  },
});

/**
 * Contributor function that adds custom columns to the Users grid.
 */
export function customPropContributor(propList: EntityPropList<IdentityUserDto>) {
  propList.addTail(paypalPayerIdProp);
  propList.addTail(paypalEmailAddressProp);
  propList.addTail(klaviyoProfileIdProp);
}

/**
 * Entity prop contributors for the Identity module.
 */
export const identityEntityPropContributors: IdentityEntityPropContributors = {
  [eIdentityComponents.Users]: [customPropContributor],
};
